module.exports = __webpack_public_path__ + "img/hockey.dcefda0b.svg";